/**
 * The window title.
 *
 * ⚠️ IT WAS A FIXED ARABIC STRING IN `index.html` AND NEVER CHANGED — not for the interface
 * language, not for the page. So an English-speaking customer had an Arabic browser tab, every tab
 * said the same thing, and somebody with four sites open could not tell them apart. A title is not
 * decoration: it is what a tab strip, a bookmark, a shared link and a screen reader's window list
 * all read from.
 *
 * ⚠️ EACH PAGE OWNS ITS OWN, rather than one switch in the router keyed on the path. The editor's
 * title is the site's name, which only the editor has; a central version would need the route table
 * to know how to load a site in order to name a tab.
 *
 * The suffix is added here so that every title ends the same way and no caller can forget it —
 * and it is dropped when the page IS the product's front door, because "ksa-web.app — ksa-web.app"
 * is what happens when a rule is applied without an exception.
 */

import { useEffect } from 'react'
import { useLang } from '@ksa/ui'

const SUFFIX = 'ksa-web.app'

export function useTitle(en: string, ar: string): void {
  const { lang } = useLang()

  useEffect(() => {
    const title = lang === 'ar' ? ar : en
    document.title = title === SUFFIX ? title : `${title} — ${SUFFIX}`
  }, [en, ar, lang])
}
